<template>
  <label class="block text-sm font-medium text-gray-700"> {{label}}
    <textarea
        class="autoexpand tracking-wide py-2 px-4 mt-2 mb-3 leading-relaxed appearance-none block w-full bg-white border border-gray-200 text-gray-700 rounded-lg focus:outline-none
     focus:bg-white"
        v-bind:placeholder="placeholder" :value="value"
        @input="$emit('input', $event.target.value)"></textarea>
  </label>
</template>

<script>
export default {
  name: "textareacomponent",
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    label:{
      type:String,
      default:''
    }
  }
}
</script>

<style scoped>

</style>